<template>
  <tr>
    <slot />
  </tr>
</template>
<style scoped>
tr {
  border-bottom: 1px solid #c9c9c9;
}
</style>
